import { atom, selector } from 'recoil';
import { updateUserWorkspacePanel } from '@/component/multiPanel/handler/WrapPanelHandler';
import localStorageUtil from '@/common/utils/localStorageUtil';


/**
 * Create store save panel state
 */
export const multiPanelAtom = atom({
    key: 'multiPanelAtom',
    default: [],
    effects: [
        ({onSet}) => {
            onSet(async newState  => {
                // console.log('updateUserWorkspacePanel newState')
                await updateUserWorkspacePanel(newState);
            });
        },
    ],
})



/**
 * Define start index of multi panel
 */
export const panelStartIndexAtom = atom({
    key: 'panelStartIndexAtom',
    default: 0
});


/**
 * Define start index of multi panel
 */
export const panelSlideCurrentIndexAtom = atom({
    key: 'panelSlideCurrentIndexAtom',
    default: 0
});


export const closeTabId = atom({
    key: 'closeTabId',
    default: 0
})

export const isEditedMsgInprogressAtom = atom({
    key: 'isEditedMsgInprogressAtom',
    default: false
})


/**
 * Define slider setting
 */
 export const panelSettingAtom = atom({
    key: 'panelSettingAtom',
    default: {
        controls: false,
        disable: false,
        lazyload: false,
        nav: false,
        touch: true,
        mouseDrag: false, //swipe on PC
        loop: false,
        items: 1,
        preventScrollOnTouch: 'false',
        responsive: false,
        container: '#fixedWidth',
        autoWidth: true,
        // "fixedWidth": 400,
        // "swipeAngle": false,
        // responsive: {
        //     1367: {
        //         items: 3,
        //     },
        //     927: {
        //         items: 2,
        //     },
        //     375: {
        //         items: 1,
        //     },
        // },
        startIndex: 0,
    }
});


/**
 * Reload chat thread panel atom
 */
export const reloadChatThreadPanelAtom = atom({
    key: 'reloadChatThreadPanelAtom',
    default: false
});

export const isOnMobileDisplayMenuAtom = atom({
    key: 'isOnMobileDisplayMenuAtom',
    default: false
});

export const isOnMobileDisplayKnowledgeAtom = atom({
    key: 'isOnMobileDisplayKnowledgeAtom',
    default: false
});

export const reloadListTicketKnowleadPanel = atom({
    key: 'reloadCustomerTicketKnowleadPanel',
    default: ''
});


/**
 * panelInitData
 */
export const panelInitDataAtom = atom({
    key: 'panelInitDataAtom',
    default: []
});


export const lastActivePanelIdAtom = atom({
    key: 'lastActivePanelIdAtom',
    default: {}
});

export const triggerReloadMenuAtom = atom({
    key: 'triggerReloadMenuAtom',
    default: ''
});

export const isSetDefaultPanelAtom = atom({
    key: 'isSetDefaultPanelAtom',
    default: selector({
        key: 'isSetDefaultPanelSelector',
        get: ({ get }) => {
            if (localStorageUtil.getGuestCustomerQueryParam() && 
                localStorageUtil.getDestinationProjectQueryParam() &&
                localStorageUtil.getSubDomainIframe() === localStorageUtil.getCorporationDomain()
            ) {
                return true;
            } else {
                return false;
            }
        },
    })
})

export const reloadEditContractTabIdAtom  = atom({
    key: 'reloadEditContractTabIdAtom',
    default: 'tabId'
})

export const knowledgeViewSelectedAtom = atom({
    key: 'knowledgeViewSelectedAtom',
    default: {}
});

export const listenOnChangeKnowledgeViewSelectedAtom = atom({
    key: 'listenOnChangeKnowledgeViewSelectedAtom',
    default: {}
})

export const isUsingChatAIAtom = atom({
    key: 'isUsingChatAIAtom',
    default: true
});


export const reloadTicketDetailIdAtom = atom({
    key: 'reloadTicketDetailIdAtom',
    default: ''
});

export const isLoadingChangeWorkspaceAtom = atom({
    key: 'isLoadingChangeWorkspace',
    default: false
})

/**
 * Manage dirty state and panel-close confirmation for LOCAL_MCP_CATALOG panel.
 * - isDirty: true when the create/edit form has unsaved changes
 * - isClosePanel: set to true by PanelHandler to signal the component to show COMMSG044
 */
export const mcpCatalogPanelAtom = atom({
    key: 'mcpCatalogPanelAtom',
    default: {
        isDirty: false,
        isClosePanel: false,
        closeSource: null
    }
});


/**
 * MCP-003-F3 BR-11: Stores latest localMcpActivated changes from toggle actions.
 * Structure: { userLocalMcp: { [rawCatId]: boolean }, projectLocalMcp: { [rawCatId]: boolean } }
 * UserProfile watches userLocalMcp to refresh tab visibility.
 * MCPServerSetting watches projectLocalMcp for showProjectLocalMcpTab.
 */
export const mcpActivationChangedAtom = atom({
    key: 'mcpActivationChangedAtom',
    default: { userLocalMcp: {}, projectLocalMcp: {} }
});
